import script from "./RemoveUserFromGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveUserFromGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./RemoveUserFromGroupModal.vue?vue&type=style&index=0&id=c3d3d2f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3d3d2f2"]])

export default __exports__